import { useTranslation } from "react-i18next";
import { usePwaInstallPrompt } from "../../hooks/usePwaInstallPrompt";

export function ClientInstallPrompt() {
  const { t } = useTranslation();
  const { canInstall, isPrompting, dismiss, promptInstall } = usePwaInstallPrompt();

  if (!canInstall) return null;

  return (
    <section className="rounded-2xl border border-teal-200 bg-teal-50 p-4 text-left">
      <h3 className="text-base font-semibold text-slate-800">{t("client.pwa.title")}</h3>
      <p className="mt-1 text-sm text-slate-600">{t("client.pwa.body")}</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <button className="btn w-full sm:w-auto" type="button" onClick={() => void promptInstall()} disabled={isPrompting}>
          {isPrompting ? t("client.pwa.installing") : t("client.pwa.install")}
        </button>
        <button className="btn secondary w-full sm:w-auto" type="button" onClick={dismiss}>
          {t("client.pwa.dismiss")}
        </button>
      </div>
    </section>
  );
}
